<template>
  <b-modal
    id="sendProcedureModal"
    size="md"
    modal-class="modal-datepicker"
    header-bg-variant="lisaweb"
    body-class="pt-3"
    footer-class="py-2 px-3"
    no-close-on-backdrop
    @hidden="reset"
  >
    <template #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <span>Invio procedura</span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="cancel()"
      >
        <base-icon name="close" width="14" height="14" />
      </button>
    </template>

    <validation-observer ref="observer">
      <b-form @submit.prevent="">
        <base-radio
          vid="mode"
          name="modalità"
          label="Quando inviare"
          v-model="mode"
          :options="modeOptions"
          :rules="{ required: true }"
          stacked
        />

        <div v-if="isScheduled" class="mt-2">
          <base-datepicker
            vid="scheduled_date"
            name="data"
            label="Data invio"
            v-model="form.date"
            :rules="{ required: true }"
          />
          <base-timepicker
            vid="scheduled_time"
            name="ora"
            label="Ora invio"
            v-model="form.time"
            :rules="{ required: true }"
          />
          <b-alert v-if="isPast" show variant="warning" class="mt-2 mb-0 py-2">
            La data indicata è già passata: scegline una futura, oppure invia
            subito.
          </b-alert>
        </div>
      </b-form>
    </validation-observer>

    <!--
      Footer custom e non showConfirm: msgBoxConfirm ha solo due pulsanti e
      instrada nel ramo "no" anche la chiusura con Esc/backdrop, quindi la scelta
      fra invio immediato e programmato ci finirebbe dentro per sbaglio.
      Il pulsante non legge lo scope del validation-observer perché lo slot
      modal-footer deve restare figlio diretto di b-modal: la validità è quella
      calcolata da canConfirm.
    -->
    <template #modal-footer="{ cancel }">
      <b-form-group class="mb-0">
        <div class="d-flex">
          <b-button
            @click="cancel()"
            class="btn--transparent mr-2"
            size="sm"
            variant="outline-secondary"
            >Annulla
          </b-button>
          <b-button
            @click="onSend(cancel)"
            size="sm"
            variant="lisaweb"
            :disabled="!canConfirm"
            >{{ isScheduled ? "Programma" : "Invia" }}
          </b-button>
        </div>
      </b-form-group>
    </template>
  </b-modal>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import BaseRadio from "@/components/form/BaseRadio";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import BaseTimepicker from "@/components/form/BaseTimepicker";
import moment from "moment";

/*
 * Scelta fra invio immediato e invio programmato, allo step 4 del wizard.
 *
 * Emette sempre "send" con la data scelta: null significa "subito". Chi ascolta
 * usa quel valore sia per lo stato della procedura (5 Invio / 6 Schedulato) sia
 * per il payload verso LisaComunica, che con una data nulla o passata dispaccia
 * immediatamente.
 *
 * Data e ora sono due componenti distinti perché non esiste un datetimepicker
 * unico nel progetto; il controllo "non nel passato" sta qui e non in una regola
 * vee-validate perché nasce dalla combinazione dei due campi.
 */
export default {
  name: "SendProcedureModal",
  components: { BaseIcon, BaseRadio, BaseDatepicker, BaseTimepicker },
  data() {
    return {
      mode: "now",
      modeOptions: [
        { text: "Invia subito", value: "now" },
        { text: "Programma l'invio", value: "scheduled" },
      ],
      form: {
        date: null,
        time: null,
      },
    };
  },
  computed: {
    isScheduled() {
      return this.mode === "scheduled";
    },
    scheduledAt() {
      if (!this.isScheduled || !this.form.date || !this.form.time) {
        return null;
      }
      return moment(
        `${this.form.date} ${this.form.time}`,
        "YYYY-MM-DD HH:mm"
      ).format("YYYY-MM-DD HH:mm:ss");
    },
    isPast() {
      return (
        !!this.scheduledAt && moment(this.scheduledAt).isSameOrBefore(moment())
      );
    },
    canConfirm() {
      return this.isScheduled ? !!this.scheduledAt && !this.isPast : true;
    },
  },
  methods: {
    onSend(cancel) {
      const scheduledAt = this.scheduledAt;
      cancel();
      this.$emit("send", scheduledAt);
    },
    reset() {
      this.mode = "now";
      this.form.date = null;
      this.form.time = null;
    },
  },
};
</script>
